const formatNumber = (value) => {
  if (value === null || value === undefined || value === 0) return '0';
  return new Intl.NumberFormat('pt-BR').format(value);
};

const formatPercent = (value) => {
  if (value === null || value === undefined) return '0%';
  return `${parseFloat(value).toFixed(2).replace('.', ',')}%`;
};

export {
  formatNumber,
  formatPercent
}
